import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { apiFetch } from "../../api/apiFetch";
import ErrorModal from "../../components/ErrorModal";
import { MONTH_NAMES, PERIOD_STATUS, apiErrorMessage, formatDate, formatEuro, formatHoursMinutes } from "../../utils/timesheets";

/** Wachtrij van maanden die op goedkeuring of vrijgave wachten. */
export default function Approvals() {
  const [rows, setRows] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    apiFetch("/timesheets/approvals")
      .then(setRows)
      .catch((err) => setError(apiErrorMessage(err)));
  }, []);

  return (
    <div className="p-4 sm:p-6 max-w-full">
      {error && <ErrorModal message={error} onClose={() => setError("")} />}
      <h1 className="text-2xl font-bold text-gray-800 mb-2">Goedkeuring prestaties</h1>
      <p className="text-sm text-gray-500 mb-4">Ingediende maanden die op goedkeuring wachten, en maanden waarvoor vrijgave gevraagd is.</p>

      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-x-auto">
        <table className="w-full text-sm" style={{ minWidth: 800 }}>
          <thead>
            <tr className="bg-gray-50 border-b border-gray-100 text-xs text-gray-500 uppercase">
              <th className="px-4 py-2 text-left">Personeelslid</th>
              <th className="px-4 py-2 text-left">Maand</th>
              <th className="px-4 py-2 text-left">Status</th>
              <th className="px-4 py-2 text-left">Ingediend</th>
              <th className="px-4 py-2 text-right">Gewerkt</th>
              <th className="px-4 py-2 text-right">Kost</th>
              <th className="px-4 py-2 text-left">Opmerking</th>
              <th className="px-4 py-2"></th>
            </tr>
          </thead>
          <tbody>
            {rows === null && (
              <tr><td colSpan={8} className="px-4 py-10 text-center text-gray-400">Laden...</td></tr>
            )}
            {rows !== null && rows.length === 0 && (
              <tr><td colSpan={8} className="px-4 py-10 text-center text-gray-400">Niets dat op goedkeuring wacht.</td></tr>
            )}
            {(rows || []).map((r) => {
              const badge = PERIOD_STATUS[r.status];
              return (
                <tr key={r.id} className="border-b border-gray-50 hover:bg-gray-50">
                  <td className="px-4 py-2 text-gray-800">{r.member_naam}</td>
                  <td className="px-4 py-2 text-gray-700 capitalize">{MONTH_NAMES[r.month - 1]} {r.year}</td>
                  <td className="px-4 py-2">
                    <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${badge.className}`}>{badge.label}</span>
                  </td>
                  <td className="px-4 py-2 text-gray-600">{r.submitted_at ? formatDate(r.submitted_at.slice(0, 10)) : ""}</td>
                  <td className="px-4 py-2 text-right tabular-nums">{r.minutes ? formatHoursMinutes(r.minutes) : ""}</td>
                  <td className="px-4 py-2 text-right tabular-nums">{formatEuro(r.cost)}</td>
                  <td className="px-4 py-2 text-gray-500 truncate max-w-xs" title={r.release_reason || ""}>{r.release_reason || ""}</td>
                  <td className="px-4 py-2 text-right">
                    <Link
                      to={`/timesheets?member_id=${r.member_id}&year=${r.year}&month=${r.month}`}
                      className="px-3 py-1.5 text-xs font-medium bg-blue-600 text-white rounded hover:bg-blue-700"
                    >
                      Bekijken
                    </Link>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
